import { type ReactNode } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import defaultImage from '@/assets/images/png/default-path-image.png';
import {
  ResourceCard,
  ResourceCardContainer,
  ResourceCardContent,
  ResourceCardHeader,
  ResourceCardSubtitle,
  ResourceCardTitle,
} from '@/components/shared/resource-card';
import { lineClamp } from '@/utils/line-clamp';

export type LearningTypeCardProps = {
  description: string;
  image: string;
  label: string;
  link?: string;
  customAction?: ReactNode;
  info?: string;
  onClick?: () => void;
};

export const LearningTypeCard = ({
  label,
  image,
  description,
  link,
  customAction,
  info,
  onClick,
}: LearningTypeCardProps) => {
  const navigate = useNavigate();

  return (
    <ResourceCard
      onClick={() => (onClick ? onClick() : link ? navigate(link) : undefined)}
      href={link ?? undefined}
    >
      <ResourceCardHeader
        image={{ src: image ?? defaultImage, alt: "", type: 'image' }}
      />
      <ResourceCardContainer>
        <ResourceCardContent>
          <ResourceCardTitle lines={2}>{label}</ResourceCardTitle>
          {info && <ResourceCardSubtitle>{info}</ResourceCardSubtitle>}
          <Typography sx={lineClamp(3)}>{description}</Typography>
        </ResourceCardContent>
        {customAction}
      </ResourceCardContainer>
    </ResourceCard>
  );
};
